import { MESApiService, getMomentTz, spParameter } from "@dexteel/mesf-core";

const moment = getMomentTz();

export const getLadleMaintenance = async ({
  ladleId,
  start,
}: {
  ladleId: number;
  start?: Date;
}) => {
  start = moment(start).startOf("day").toDate();
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "LadleId", value: ladleId },
    { name: "Start", value: start?.toISOString() ? start : null },
  ];

  try {
    const response = await apiService.callV2(
      "[RBD].[GetLadleMaintenance]",
      parameters,
    );

    if (!response.ok) {
      return {
        ok: false,
        message: response.message,
      };
    }

    const table = response?.data?.tables[0];
    const rows = table.rows || [];

    const groupedData = groupByCampaign(rows);

    const relinings = Object.values(groupedData).map((group: any) => ({
      LadleReliningId: group.key.LadleReliningId || null,
      StartCampaign: group.key.StartCampaign
        ? moment.utc(group.key.StartCampaign).toDate()
        : null,
      EndCampaign: group.key.EndCampaign
        ? moment.utc(group.key.EndCampaign).toDate()
        : null,
      Heats: group.key.Heats || null,
      ContactTime: group.key.ContactTime || null,
      LadleCondition: group.key.LadleCondition || null,
      Plugs: group.plugs.map((plug: any) => ({
        PlugChangeId: plug.PlugChangeId || null,
        PlugStart: plug.PlugStart ? moment.utc(plug.PlugStart).toDate() : null,
        PlugEnd: plug.PlugEnd ? moment.utc(plug.PlugEnd).toDate() : null,
        PlugHeats: plug.PlugHeats || null,
        PlugInsideTime: plug.PlugInsideTime || null,
        PlugOutsideTime: plug.PlugOutsideTime || null,
        Editable: plug.Editable || false,
      })),
    }));

    return {
      ok: true,
      data: relinings,
    };
  } catch (error: any) {
    return {
      ok: false,
      message: error.toString(),
    };
  }
};

const groupByCampaign = (rows: any[]) => {
  return rows.reduce((acc: any, row: any) => {
    const key = `${row.LadleReliningId}`;

    if (!acc[key]) {
      acc[key] = {
        key: {
          LadleReliningId: row.LadleReliningId,
          StartCampaign: row.StartCampaign,
          EndCampaign: row.EndCampaign,
          Heats: row.Heats,
          ContactTime: row.ContactTime,
          LadleCondition: row.LadleCondition,
        },
        plugs: [],
      };
    }

    acc[key].plugs.push({
      PlugChangeId: row.PlugChangeId,
      PlugStart: row.PlugStart,
      PlugEnd: row.PlugEnd,
      PlugHeats: row.PlugHeats,
      PlugInsideTime: row.PlugInsideTime,
      PlugOutsideTime: row.PlugOutsideTime,
      Editable: row.Editable,
    });

    return acc;
  }, {});
};

export const upsertLadleRelining = async ({
  ladleReliningId,
  ladleId,
  timestamp,
}: {
  ladleReliningId: number | null;
  ladleId: number;
  timestamp?: Date | null;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "LadleReliningId", value: ladleReliningId },
    { name: "LadleId", value: ladleId },
    { name: "Timestamp", value: timestamp ? timestamp.toISOString() : null },
  ];

  return await apiService.callV2("[MS].[UpsertLadleRelining]", parameters);
};

export const upsertPlugChange = async ({
  plugChangeId,
  ladleId,
  timestamp,
}: {
  plugChangeId: number | null;
  ladleId: number;
  timestamp?: Date | null;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "PlugChangeId", value: plugChangeId },
    { name: "LadleId", value: ladleId },
    { name: "Timestamp", value: timestamp ? timestamp.toISOString() : null },
  ];

  return await apiService.callV2("[MS].[UpsertPlugChange]", parameters);
};

export const deletePlugById = async (id: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "PlugChangeId", value: id }];

  return await apiService.callV2("[MS].[DeletePlugChange]", parameters);
};

export const deleteReliningById = async (id: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "LadleReliningId", value: id }];

  return await apiService.callV2("[MS].[DeleteLadleRelining]", parameters);
};
